import { render } from "./Start.vue?vue&type=template&id=03bbeefe&ts=true&lang=pug"
import script from "./Start.vue?vue&type=script&lang=ts"
export * from "./Start.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/kaplife/telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__